import type { BffLogicalDeviceResourceReadApi } from '@ingenico/api-sdk-provisioning-private';
import { CoreContainer } from '@ingenico/react-ui/core-container';
import type { ReactElement } from 'react';
import type { DeviceMetrics } from '../../domain/models';
import type { RightColumnExtensionContainerReadyHandler } from '../../domain/models/logicalDeviceAttachedDevicePanel.model';
import type { PhysicalDeviceInformation } from '../../domain/models/physicalDeviceInformation.model';
import { LogicalDeviceTerminalDetailsCard } from '../logical-device-terminal-details-card/LogicalDeviceTerminalDetailsCard.ctrl';
import { TetraDeviceInfoCard } from '../tetra-device-info-card/TetraDeviceInfoCard.ctrl';
import styles from './MinimalDeviceLayout.module.scss';

interface MinimalDeviceLayoutProps {
  readonly logicalDeviceDetails?: BffLogicalDeviceResourceReadApi | null;
  readonly deviceMetrics?: DeviceMetrics | null;
  readonly shouldShowTerminalDetails: boolean;
  readonly shouldDisplayCustomerLayout?: boolean;
  readonly physicalDeviceInfo?: PhysicalDeviceInformation | null;
  readonly onRightColumnExtensionContainerReady?: RightColumnExtensionContainerReadyHandler;
}

export function MinimalDeviceLayout({
  logicalDeviceDetails,
  deviceMetrics,
  shouldShowTerminalDetails,
  shouldDisplayCustomerLayout,
  physicalDeviceInfo,
  onRightColumnExtensionContainerReady,
}: MinimalDeviceLayoutProps): ReactElement {
  return (
    <div>
      <CoreContainer customMainClassName={styles.container}>
        <div className={styles.tetraContentWrapper}>
          {/* Left Column: Tetra Device Info Card */}
          <div className={styles.tetraLeftColumn}>
            <div className={styles.tetraDeviceInfoCard}>
              <TetraDeviceInfoCard
                physicalDevice={physicalDeviceInfo}
                attachedPhysicalDevice={logicalDeviceDetails?.attachedPhysicalDevices?.[0]}
              />
            </div>
          </div>

          {/* Right Column: Other Sections */}
          <div className={styles.tetraRightColumn}>
            {onRightColumnExtensionContainerReady && (
              <div className={styles.rightColumnExtensionContainer} ref={onRightColumnExtensionContainerReady} />
            )}
            {shouldShowTerminalDetails && (
              <div className={styles.tetraSection}>
                <LogicalDeviceTerminalDetailsCard
                  metrics={deviceMetrics}
                  physicalDevice={logicalDeviceDetails?.attachedPhysicalDevices?.[0]}
                  logicalDeviceReference={logicalDeviceDetails?.reference}
                  shouldDisplayCustomerLayout={shouldDisplayCustomerLayout}
                />
              </div>
            )}
          </div>
        </div>
      </CoreContainer>
    </div>
  );
}
